/*
Copyright 2020 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const Cross600Icon = ({ width = 24, height = 24, hidden = false, title = 'Cross600' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
    width="${width}"
    height="${height}"
  >
    <path
      d="m9.518 8 5.23-5.228a1.073 1.073 0 0 0-1.518-1.518L8.001 6.483l-5.229-5.23a1.073 1.073 0 0 0-1.518 1.519L6.483 8l-5.23 5.229a1.073 1.073 0 1 0 1.518 1.518l5.23-5.23 5.228 5.23a1.073 1.073 0 0 0 1.518-1.518z"
    />
  </svg>`;
};
